export default __webpack_public_path__ + "static/media/icon_guide_download.09432b83.svg";